module.exports = __webpack_public_path__ + "img/nonEditable_info2.d6b49660.png";